import { TFunction } from "i18next";
import { v4 as uuid } from "uuid";
import * as yup from "yup";

export interface Target {
  id: string;
  name: string;
  emails: string[];
  description: string;
  attribute?: string;
}

export const TargetValidation = (t: TFunction) =>
  yup.object({
    name: yup.string().required(t("validation.user.name.required")),
    emails: yup
      .array()
      .of(
        yup
          .string()
          .required(t("validation.user.email.required"))
          .email(t("validation.user.email.valid"))
      )
      .required("test.at least one email required."),
  });

export const createTarget = (
  name: string = "",
  emails: string[] = [''],
  description: string = "",
  attribute: string = ""
): Target => ({
  id: uuid(),
  name: name,
  emails: emails,
  description: description,
  attribute: attribute,
});

/**
 * Make a deep copy of a target object
 * @param target The source target object
 * @returns Deep copy of target object
 */
export const cloneTarget = (target: Target): Target => {
  return {
    id: target.id,
    name: target.name,
    emails: [...target.emails],
    description: target.description,
    attribute: target.attribute,
  };
};

/**
 * Provide a deep copy of a target array
 * @param targets The source array
 * @returns Deep copy of source array
 */
export const cloneTargetArray = (targets: Target[]): Target[] => {
  return targets.map((target) => cloneTarget(target));
};

export const useTargetFields = (t: TFunction) => ({
  name: t("models.target.name"),
  emails: t("models.target.emails"),
  description: t("models.target.description"),
  attribute: t("models.target.attribute"),
});
